<template>
  <div
    v-if="extras.groupNewsDisplay && extras.groupNewsDisplay.display === 1"
    :style="{
      background:
        extras.newsBg.colorOrBg == 'color'
          ? extras.newsBg.color
          : 'url(' + extras.newsBg.src + ')',
    }"
    class="m-journalism top-nav new"
    id="news"
  >
    <WapTitle
      v-if="extras.newsTitle.display === 1"
      :title="extras.newsTitle.mainTitle || title"
      :en="extras.newsTitle.subTitle || 'News'"
      :extras="extras"
    />

    <div
      class="m-tab-list-new-wap"
      :class="'tab-length' + columns.length"
      v-if="columns.length > 1 || (columns.length == 1 && columns[0].id != 0)"
    >
      <div
        class="tab-new"
        v-for="(item, index) in columns"
        :key="index"
        :class="{
          active: item.id == currentId,
        }"
        @click="columnClick(item)"
      >
        {{ item.name }}
        <div data-v-2a8f24dd="" class="underline"></div>
      </div>
    </div>

    <div
      class="g-news-list-new-wap"
      :class="extras.newsStyle.style == '1' ? 'single-line' : ''"
      v-if="articles && articles.length > 0"
    >
      <div
        class="item"
        v-for="(item, i) in articles"
        :key="i"
        :style="{
          background:
            extras.newsItemBg.colorOrBg == 'color'
              ? extras.newsItemBg.color
              : 'url(' + extras.newsItemBg.src + ')',
        }"
      >
        <div class="date">
          <div
            class="day"
            v-if="extras.newsDay.display == 1"
            :style="{
              color:
                extras.newsDay.text == 'custom' ? extras.newsDay.fontColor : '',

              'font-style':
                extras.newsDay.text == 'custom'
                  ? extras.newsDay.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras.newsDay.text == 'custom'
                  ? extras.newsDay.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            }"
          >
            {{ item.pushTime ? item.pushTime.substr(5, 5) : "" }}
          </div>
          <div
            class="year"
            v-if="extras.newsYear.display == 1"
            :style="{
              color:
                extras.newsYear.text == 'custom'
                  ? extras.newsYear.fontColor
                  : '',

              'font-style':
                extras.newsYear.text == 'custom'
                  ? extras.newsYear.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras.newsYear.text == 'custom'
                  ? extras.newsYear.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            }"
          >
            {{ item.pushTime ? item.pushTime.substr(0, 4) : "" }}
          </div>
        </div>
        <div class="info">
          <a
            class="title"
            target="_blank"
            v-if="extras.newsTitleStyle.display == 1 && item.useLinkUrl == 1"
            :href="item.linkUrl"
            :style="{
              color:
                extras.newsTitleStyle.text == 'custom'
                  ? extras.newsTitleStyle.fontColor
                  : '',

              'font-style':
                extras.newsTitleStyle.text == 'custom'
                  ? extras.newsTitleStyle.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras.newsTitleStyle.text == 'custom'
                  ? extras.newsTitleStyle.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            }"
            >{{ item.name }}</a
          >
          <a
            class="title"
            target="_blank"
            v-if="extras.newsTitleStyle.display == 1 && item.useLinkUrl != 1"
            :href="item.shortUrl"
            :style="{
              color:
                extras.newsTitleStyle.text == 'custom'
                  ? extras.newsTitleStyle.fontColor
                  : '',

              'font-style':
                extras.newsTitleStyle.text == 'custom'
                  ? extras.newsTitleStyle.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras.newsTitleStyle.text == 'custom'
                  ? extras.newsTitleStyle.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            }"
            >{{ item.name }}</a
          >
          <div
            class="desc"
            v-if="extras.newsDesc.display == 1"
            :style="{
              color:
                extras.newsDesc.text == 'custom'
                  ? extras.newsDesc.fontColor
                  : '',
              'font-style':
                extras.newsDesc.text == 'custom'
                  ? extras.newsDesc.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras.newsDesc.text == 'custom'
                  ? extras.newsDesc.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            }"
          >
            {{ item.desc }}
          </div>
        </div>
      </div>
    </div>
    <div class="no-data" v-if="articles.length == 0">
      <img :src="require('@/assets/images/nodata.png')" />
      <div class="no-data-text">暂无数据</div>
    </div>
  </div>
</template>

<script>
import WapTitle from "./Title.vue";
import { URLS } from "fire-wind-water";
export default {
  props: {
    newsInfo: [],
    extras: Object,
  },
  components: {
    WapTitle,
  },
  data() {
    return {
      title: "新闻资讯",
      icon: require("@/assets/images/wap/xinwen.png"),
      columns: [],
      articles: [],
      currentId: 0,
      isShowMore: false,
    };
  },
  created() {},
  computed: {
    // columns() {
    //   let tempArticles = this.newsInfo.article;
    //   let tempColumns = this.newsInfo.column;
    //   const columns = [
    //     {
    //       id: 0,
    //       name: "新闻资讯",
    //       article: tempArticles,
    //     },
    //   ];
    //   for (let item in tempArticles) {
    //     if (item.desc) {
    //       item.desc = item.desc.substr(0, 130);
    //     }
    //   }
    //   for (let i in tempColumns) {
    //     columns.push(tempColumns[i]);
    //   }
    //   return columns;
    // },
    // articles() {
    //   return this.columns[this.currentId].article;
    // },
  },
  mounted() {
    //this.initColumns();
    let tempColumns = this.getColumns.articleInitColumns(
      this.newsInfo.column,
      this.newsInfo.article,
      "热门资讯",
      true
    );
    this.columns = tempColumns;
    this.articles = this.columns[0] ? this.columns[0].article : [];
    this.currentId = this.columns[0] ? this.columns[0].id : 0;
  },
  methods: {
    columnClick(item) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.currentId = item.id;
      this.articles = item.article;
    },

    showMoreArticle() {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.isShowMore = !this.isShowMore;
    },
  },
};
</script>
<style scoped></style>
